import HomeLayout from "../../commonComponents/HomeLayout";

const RefundPolicy = () => {
  return (
    <HomeLayout>
      <section className="items-center body-description px-8 sm:px-10 lg:px-[174px] pt-[30px] max-w-[1300px] mx-auto">
        <h2 className="h2">
          Refund Policy for Property Purchase on the Home and Abroad Platform
        </h2>
        <p className="body-description mt-10 mb-3 text-justify">
          This Refund Policy outlines the terms and conditions under which
          refunds may be processed for transactions conducted on the Home and
          Abroad platform (the “Platform”). This policy ensures transparency,
          fairness, and efficiency for all parties involved, including buyers
          and sellers.
        </p>
        <p className="body-description">
          <span className="font-semibold block mb-2">
            1. Buyer-Initiated Cancellation Within Document Preparation Period
            (Cancellation not as of right)
          </span>
          Where a buyer requests cancellation of a transaction and a refund
          within the 1 -5 business days allocated for the seller to prepare and
          upload necessary property documents on the Platform (Cancellation not
          as of right), the refund will be processed as follows:
        </p>
        <ul className="body-description pl-6">
          <li>
            a. The buyer will be refunded only the amount paid directly towards
            the property
          </li>{" "}
          <li>
            b. All associated costs and charges, including but not limited to
            bank fees,{" "}
          </li>
        </ul>
        <p className="body-description font-semibold mt-5 mb-2">
          2. Buyer’s Failure to Approve Documents or Authorize Payment
        </p>
        <p className="body-description">
          Buyers are required to review and approve, once satisfied, all
          property documents uploaded by the seller within 14-21 business days
          of the documents being uploaded. Where the uploaded documents are
          shown to be genuine and the buyer still fails to, within the
          aforementioned period:
        </p>
        <ul className="body-description pl-6">
          <li>
            a. Send a Letter of Authorization to First Bank (the escrow account
            handler) for fund disbursement, and{" "}
          </li>
          <li>
            b. All attempts by the Platform to get the buyer send the letter of
            authorization above within the above-stated period are unsuccessful;
            the Platform reserves the right to notify First Bank to refund the
            buyer the property value, excluding all associated charges (e.g.,
            bank fees, transaction fees, and platform service fees).
          </li>
        </ul>
        <p className="body-description font-semibold mt-5 mb-2">
          3. Seller’s Failure to Provide Property Documents (Buyer’s
          cancellation as of right)
        </p>
        <ul className="body-description pl-6">
          <li>
            a. Where a developer fails to provide all required property
            documents within the initial 1-5 business days of a buyer making p
            ayment, the Platform shall promptly inform the buyer of the delay
            and request an additional 5 business days (“extended period”) for
            the seller to provide the documents. The buyer in this instance is
            not entitled to demand a refund.
          </li>
          <li>
            b. Where the seller fails to provide the documents by the end of the
            extended period, the buyer is entitled to demand a refund(Buyer’s
            cancellation as of right). The refund shall include the property
            value and the platform service fee, less any bank or transaction
            charges incurred.
          </li>
        </ul>
        <p className="body-description font-semibold mt-5 mb-2">
          4. Cancellation and Refund Due to Bad Title
        </p>
        <p className="body-description mb-2">
          Where a title search or due diligence process by the buyer reveals a
          defective or bad title (e.g., liens, encumbrances, existing mortgages,
          or legal disputes rendering the title unmarketable, etc.), the buyer
          may request cancellation of the transaction and a refund. In such
          cases:
        </p>
        <ul className="body-description pl-6">
          <li>
            a. The buyer will be refunded the full a mount paid for the property
            and any platform service fees, less any bank charges and third-party
            transaction fees incurred during the process.
          </li>
          <li>
            b. The buyer must provide evidence of the bad title (e.g., title
            search report or legal documentation) to initiate the refund
            process.
          </li>
        </ul>
        <p className="body-description font-semibold mt-5 mb-2">
          5. Ground for No Refund
        </p>
        <p>
          Where the transaction between the buyer and the seller has been
          concluded, that is upon the execution of the final counterpart of the
          final document evidencing the transaction, the buyer shall no longer
          be entitled to demand or receive any refund, partly or wholly, of any
          amount paid under the transaction
        </p>
        <p className="font-semibold mt-5 mb-2">6. Non-Refundable Fees</p>
        <p className="mb-2">
          The following fees are non-refundable under any circumstances:
        </p>
        <ul className="pl-6">
          <li>
            a. Bank transaction fees (inclusive of the fee for issuance of a
            letter of comfort from First bank to the buyer, where applicable)
          </li>
          <li>b. Third-party processing fees</li>
          <li>
            c. Currency conversion fees, where there has been a transaction
            involving payments in a currency different from the buyer’s original
            payment currency.
          </li>
          <li>
            d. Any additional costs incurred due to external services utilised
            during the transaction process.
          </li>
        </ul>
        <p className="font-semibold mt-5 mb-2">7. Refund Processing Time</p>
        <p>
          Refunds approved under this policy will be processed and paid within
          7-14 business days, depending on the payment method and banking
          processes. The Platform is not responsible for delays caused by banks
          or third-party payment processors.
        </p>
        <p className="font-semibold mt-5 mb-2">8. Refund Channel</p>
        <p>
          All refundable fees shall be made to the same banking details from
          which the customer made the initial payment, unless otherwise agreed
          upon in writing by both parties. Refunds in a different currency will
          be subject to the exchange rate at the time of processing the refund,
          and any conversion fees will be deducted
        </p>
        <p className="font-semibold mt-5 mb-2">9. Dispute Resolution</p>
        <ul className=" pl-6">
          <li>
            a. In the event of a dispute regarding a refund, buyers and sellers
            are encouraged to contact the Platform’s customer support to resolve
            the issue.
          </li>
          <li>
            b. The Platform will mediate disputes fairly and may request
            additional documentation from either party to facilitate resolution.
          </li>
          <li>
            c. Where a resolution cannot be reached, the Platform reserves the
            right to make a decision on the dispute, after duly considering each
            party’s claims based on the evidence provided by each and the terms
            of this policy.
          </li>
        </ul>
        <p className="font-semibold mt-5 mb-2">10. Force Majeure</p>
        <p>
          The Platform shall not be liable for delays or failures in processing
          refunds due to unforeseen circumstances beyond its control, including
          but not limited to natural disasters, governmental restrictions, or
          technical failures of third-party services.
        </p>
        <p className="font-semibold mt-5 mb-2">11. Policy Amendments</p>
        <p>
          The Platform reserves the right to update or modify this Refund Policy
          at any time. Any changes will be communicated to users via the
          Platform or through email notification. Continued use of the Platform
          after such changes constitutes full and unconditional acceptance of
          the updated policy.
        </p>
        <p className="font-semibold mt-5 mb-2">12. Contact Information</p>
        <p>
          For refund requests or inquiries, please contact Home and Abroad’s
          customer support at:
        </p>
        <p className="mt-1">
          Email: <a
              href="mailto:support@homeandabroad.ng"
              className="text-primary hover:opacity-75"
            >support@homeandabroad.ng</a><br />Phone: <a className="text-primary hover:opacity-75"
                      href="tel:+2347055910000">+2347055910000</a><br /> Business Hours: Monday to Friday, 9:00 AM - 5:00 PM
          (WAT)
        </p>
      </section>
    </HomeLayout>
  );
};

export default RefundPolicy;
